export default __webpack_public_path__ + "static/media/github_explorer_logo.469cc31b.svg";